if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.querySelectorAll('[data-media-step]').forEach((button) => {
          button.addEventListener('pointerup', (event) => event.stopPropagation());
          button.addEventListener('click', () => this.stepMedia(Number(button.dataset.mediaStep)));
        });
        this.addEventListener('keydown', (event) => {
          if (!this.hasAttribute('open') || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          if (event.target.closest('deferred-media, product-model, input, textarea')) return;
          event.preventDefault();
          this.stepMedia(event.key === 'ArrowRight' ? 1 : -1);
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      stepMedia(step) {
        const items = Array.from(this.querySelector('[role="document"]').children).filter((item) => item.hasAttribute('data-media-id'));
        if (!items.length) return;
        const current = items.findIndex((item) => item.classList.contains('active'));
        const next = items[(current + step + items.length) % items.length];
        window.pauseAllMedia();
        this.showActiveMedia(next.getAttribute('data-media-id'));
      }

      showActiveMedia(mediaId = this.openedBy.getAttribute('data-media-id')) {
        const container = this.querySelector('[role="document"]');
        const items = Array.from(container.children).filter((item) => item.hasAttribute('data-media-id'));
        const activeMedia = items.find((item) => item.getAttribute('data-media-id') === mediaId) || items[0];
        if (!activeMedia) return;
        items.forEach((element) => element.classList.toggle('active', element === activeMedia));
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        container.scrollTop = 0;
        container.scrollLeft = 0;
        const counter = this.querySelector('[data-media-counter]');
        if (counter) counter.textContent = `${items.indexOf(activeMedia) + 1} / ${items.length}`;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
